// extracted by mini-css-extract-plugin
export default {"wrapper":"Mx","order_date":"Nx","loading":"Ox","banner":"Px","title":"Qx","subtitle":"Rx","fsa":"Sx"};
    if(module.hot) {
      // 1715091678769
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  